import Youtube from 'react-youtube'
import React, { useEffect, useState } from 'react'
import './Rowpost.css'
import { imageUrl,ApiKey } from '../../Constants/Constants'

import axios from '../Axios';
function RowPost(props) {
    const [movies,setMovies]=useState([])
    const [urlId,setUrlId]=useState('')
    useEffect(() => {
     axios.get(props.imgurl).then((respons)=>{
        console.log(respons.data.results);
        setMovies(respons.data.results)
        
     })
    }, [])
    const opts = {
        height: '390',
        width: '100%',
        playerVars: {
          // https://developers.google.com/youtube/player_parameters
          autoplay: 1,
        },
      };
    
      const clickMovie=(id)=>{
        console.log(id)
        axios.get(`movie/${id}/videos?api_key=${ApiKey}&language=en-US`).then((respons)=>{
            if(respons.data.results.length!==0){
                setUrlId(respons.data.results[0])
            }else{
                console.log("Not Awalebel")
            }

        })
      }
    return (
        <div className='row'>
            <h2>{props.title}</h2>
            <div className="posters">
                {movies.map((obj)=>{
                return(
                
                 <img onClick={()=>clickMovie(obj.id)} className={props.isSmall ? 'smallposter': 'poster'} src={`${imageUrl+obj.backdrop_path}`} alt="" />
                )
                
                })}
               
               
            </div>
         {urlId && <Youtube  videoId={urlId.key} opts={opts} />}  

        </div>
    )
}

export default RowPost